import { render } from "./ShiftTemplateManager.vue?vue&type=template&id=34be4674&scoped=true"
import script from "./ShiftTemplateManager.vue?vue&type=script&lang=js"
export * from "./ShiftTemplateManager.vue?vue&type=script&lang=js"

import "./ShiftTemplateManager.vue?vue&type=style&index=0&id=34be4674&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34be4674"]])

export default __exports__